import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { demoUsersModal } from '../demoUsers/demoUsers.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalGridModeService } from '../../../services/globalGridMode/globalGridMode.service';
import { GridOptions } from 'ag-grid';

@Component({
  selector: 'mobile-demo-users-modal',
  template: require('./mobile-demo-users-modal.component.html'),
  styles: [require('./mobile-demo-users-modal.component.css')]
})
export class MobileDemoUsersModalComponent extends demoUsersModal {
  getRowHeight = () => 60;

  get horizontal()
  {
    return this.workspace.horizontalMode;
  }
  
  constructor(injector: Injector,
    public activeModal: NgbActiveModal,
    protected ngbModalService: NgbModal,
    protected globalGridModeService: GlobalGridModeService,
    ) 
    { 
      super(injector, activeModal, ngbModalService, globalGridModeService);
      this.columnDefs[2].width = 120;
      this.setCellStyle(this.columnDefs[0]);
      (this.columnDefs[1] as any).hide = true;
      this.gridOptions.headerHeight = 40;
    }

    setCellStyle(columnDef: any)
    {
      columnDef.cellStyle = Object.assign(columnDef.cellStyle || {}, 
      {
        'font-size': '18px !important', 
        'line-height': this.getRowHeight() + 'px !important',
        'text-align': 'left'
      }) as any;
    }
    onGridReady(params: GridOptions) 
    {
      super.onGridReady(params);
      this.gridApi.sizeColumnsToFit();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) 
    {
      this.gridApi.sizeColumnsToFit();
    }

}
